var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-container",class:( _obj = {}, _obj['loader-container_loading'] = _vm.isLoading, _obj['loader-container_fetching'] = _vm.isFetching, _obj )},[_c('div',{staticClass:"loader"},[_vm._v("Пожалуйста, подождите...")])])}
var staticRenderFns = []

export { render, staticRenderFns }